<app-view-dashboard-component>
  <div modalTitle>
    {{ 'nav.templates' | translate}}
  </div>
  <app-templates></app-templates>
</app-view-dashboard-component>